import { render, staticRenderFns } from "./unauthorized.vue?vue&type=template&id=2569f7b9&scoped=true"
import script from "./unauthorized.vue?vue&type=script&lang=js"
export * from "./unauthorized.vue?vue&type=script&lang=js"
import style0 from "./unauthorized.vue?vue&type=style&index=0&id=2569f7b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2569f7b9",
  null
  
)

export default component.exports